(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lasura-collect-map"] && !Shopify.designMode) return;
  try {
    class LasuraCollectMap extends HTMLElement {
    connectedCallback() {
      if (
        !document.body.classList.contains('lasura-motion') ||
        matchMedia('(prefers-reduced-motion: reduce)').matches ||
        !('IntersectionObserver' in window)
      ) {
        return;
      }
      /* Only hold the drawing back while it is still below the fold; a map already on screen stays put. */
      const box = this.getBoundingClientRect();
      if (box.top < window.innerHeight) return;
      this.classList.add('is-pending');
      const seen = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        seen.disconnect();
        this.classList.add('is-in');
        requestAnimationFrame(() => requestAnimationFrame(() => this.classList.remove('is-pending')));
      }, { threshold: 0.45 });
      seen.observe(this);
    }
  }

  if (!customElements.get('lasura-collect-map')) customElements.define('lasura-collect-map', LasuraCollectMap);
  } catch(e) { console.error(e); }
})();

})();
